module.exports = __webpack_public_path__ + "img/Löwenzahnohr.010ddebd.svg";